import type { LiveFillEntry } from './api.js'

/**
 * Décrochage préfait : l'infoservice remplit la durée donnée.
 *
 * Choix de l'exploitant (02/10/2026) : dans le décrochage préfait, l'infoservice
 * comble tout le reste. Avec une durée donnée (« Sans durée fixe » décoché), il
 * prend ce qui reste de cette durée une fois les pubs et jingles posés ; sans
 * durée fixe, il tient l'antenne jusqu'au raccrochage. Ajouté à sa durée de
 * média, il débordait de la fenêtre (enregistrement refusé) ou laissait le
 * bouchon jouer la fin.
 *
 * Les modèles déjà enregistrés avec un infoservice à durée fixe sont relus avec
 * la même règle : le premier infoservice devient l'élément qui comble le reste,
 * tant qu'aucun autre ne l'est déjà.
 */
export function templateFillEntries(entries: readonly LiveFillEntry[]): LiveFillEntry[] {
  if (entries.some(entry => entry.fillRest)) return [...entries]
  const index = entries.findIndex(entry => entry.itemType === 'INFOSERVICE')
  if (index < 0) return [...entries]
  return entries.map((entry, position) => position === index
    ? { itemType: 'INFOSERVICE', fillRest: true }
    : entry)
}
